import React from 'react'
import { useTypedSelector } from 'src/State/RootReducer'
import BasicSystemTableMonthCellWrapper, {
  BasicSystemConfiguratorItem,
  BasicSystemTableMonthCellWrapperProps,
} from 'src/Libs/shop/components/SystemConfiguration/BasicSystem/BasicSystemTableMonthCellWrapper'

type NormalBasicSystemTableMonthCellProps = Omit<BasicSystemTableMonthCellWrapperProps, 'configuratorItems'>

/*
 * Handles Normal Basic System month cell redux adapter
 */
const NormalBasicSystemTableMonthCell: React.FC<NormalBasicSystemTableMonthCellProps> = props => {
  const configuratorItems: BasicSystemConfiguratorItem[] = useTypedSelector(state =>
    state.systemStorage.items.map(item => ({
      desiredShippingDate: item.desiredShippingDate,
      configuration: {
        configuratorId: item.configuration.configuratorId,
      },
    }))
  )

  return <BasicSystemTableMonthCellWrapper {...props} configuratorItems={configuratorItems} />
}

export default NormalBasicSystemTableMonthCell
